import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import type { IVipTransferFormProps } from '../../types';
import { VipFileUploader } from '../VipFileUploader';
import { useVipTransferForm } from './hooks/useVipTransferForm';
import { ScErrorText, ScVipTransferForm } from './styled';

export const VipTransferForm = ({ onSuccess }: IVipTransferFormProps) => {
  const { t } = useTranslation('vip');
  const {
    emailScreenshot,
    statusScreenshot,
    emailError,
    statusError,
    submitError,
    isRequestPending,
    handleEmailChange,
    handleStatusChange,
    handleEmailFileError,
    handleStatusFileError,
    handleSubmit,
  } = useVipTransferForm({ onSuccess });

  return (
    <ScVipTransferForm>
      <span className="title">{t('steps.vipTransfer.transferForm.title')}</span>

      <div className="uploaders-wrapper">
        <VipFileUploader
          externalError={emailError}
          file={emailScreenshot}
          isRequestPending={isRequestPending}
          onChange={handleEmailChange}
          onFileError={handleEmailFileError}
          title={t('steps.vipTransfer.transferForm.emailScreenshot')}
          withInfoIcon
        />
        <VipFileUploader
          externalError={statusError}
          file={statusScreenshot}
          isRequestPending={isRequestPending}
          onChange={handleStatusChange}
          onFileError={handleStatusFileError}
          title={t('steps.vipTransfer.transferForm.statusScreenshot')}
        />
      </div>

      {submitError && <ScErrorText>{submitError}</ScErrorText>}

      <Button
        disabled={isRequestPending}
        isLoading={isRequestPending}
        onClick={handleSubmit}
        primary
      >
        {t('steps.vipTransfer.transferForm.ctaBtn')}
      </Button>
    </ScVipTransferForm>
  );
};
